(function () {

  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  /** Surname particles — ignored when choosing letter / sort key (van Gogh → Gogh / G). */

  var PARTICLES = {

    van: 1,

    de: 1,

    der: 1,

    den: 1,

    von: 1,

    af: 1,

    della: 1,

    di: 1,

    da: 1,

    del: 1,

    la: 1,

    le: 1,

    du: 1,

  };



  function ready(fn) {

    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', fn);

    } else {

      fn();

    }

  }



  function escapeHtml(str) {

    return String(str)

      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/>/g, '&gt;')

      .replace(/"/g, '&quot;');

  }



  function stripAccents(str) {

    try {

      return String(str)

        .normalize('NFD')

        .replace(/[\u0300-\u036f]/g, '')

        .replace(/ı/g, 'i')

        .replace(/İ/g, 'I');

    } catch (e) {

      return String(str);

    }

  }



  /**

   * Art-convention surname: last meaningful token (skip particles before it).

   * Claude Monet → Monet; Wassily Kandinsky → Kandinsky; van Gogh → Gogh;

   * Henri Fantin-Latour → Fantin-Latour; Anonim → Anonim; single word → that word.

   */

  function surnameFromTitle(title) {

    var raw = String(title || '').trim();

    if (!raw) return '';

    var parts = raw.split(/\s+/).filter(Boolean);

    if (!parts.length) return '';

    if (parts.length === 1) return parts[0];

    var i = parts.length - 1;

    while (i > 0 && PARTICLES[parts[i].toLowerCase().replace(/[.,]/g, '')]) {

      i -= 1;

    }

    return parts[i];

  }



  /** Given names / particles before the surname token (Vincent van Gogh → Vincent van). */

  function givenFromTitle(title, surname) {

    var raw = String(title || '').trim();

    if (!raw) return '';

    var parts = raw.split(/\s+/).filter(Boolean);

    if (parts.length <= 1) return '';

    var i = parts.length - 1;

    while (i > 0 && PARTICLES[parts[i].toLowerCase().replace(/[.,]/g, '')]) {

      i -= 1;

    }

    if (surname && parts[i] !== surname) {

      for (var j = parts.length - 1; j >= 0; j--) {

        if (parts[j] === surname) {

          i = j;

          break;

        }

      }

    }

    return parts.slice(0, i).join(' ');

  }



  function letterFromSurname(surname) {

    var s = stripAccents(String(surname || '').trim());

    if (!s) return '';

    var ch = s.charAt(0).toUpperCase();

    if (ch >= 'A' && ch <= 'Z') return ch;

    return '';

  }



  /** King & McGaw letter page: "CÉZANNE, PAUL" */

  function surnameFirstLabel(artist) {

    var surname = artist.surname || surnameFromTitle(artist.title);

    var given = artist.given;

    if (given == null) given = givenFromTitle(artist.title, surname);

    if (!surname) return String(artist.title || '');

    if (!given) return surname;

    return surname + ', ' + given;

  }



  function enrichArtist(a) {

    var title = a.title || '';

    var surname = surnameFromTitle(title);

    var given = givenFromTitle(title, surname);

    var letter = letterFromSurname(surname);

    return {

      title: title,

      url: a.url || '#',

      letter: letter,

      surname: surname,

      given: given,

      sort: stripAccents(surname).toLowerCase(),

    };

  }



  function groupByLetter(artists) {

    var map = {};

    LETTERS.forEach(function (L) {

      map[L] = [];

    });

    artists.forEach(function (raw) {

      var a = enrichArtist(raw);

      var L = a.letter;

      if (!map[L]) return;

      map[L].push(a);

    });

    LETTERS.forEach(function (L) {

      map[L].sort(function (x, y) {

        var cmp = String(x.sort).localeCompare(String(y.sort), 'tr');

        if (cmp !== 0) return cmp;

        return String(x.title).localeCompare(String(y.title), 'tr');

      });

    });

    return map;

  }



  /**

   * @param {object} artist

   * @param {'first-last'|'surname-first'} format

   */

  function chipHtml(artist, format) {

    var label =

      format === 'surname-first' ? surnameFirstLabel(artist) : artist.title || '';

    return (

      '<a class="artists-az__chip" href="' +

      escapeHtml(artist.url) +

      '">' +

      escapeHtml(label) +

      '</a>'

    );

  }



  /** Stable 2–3 preview rows per letter (K&M variety: H≈3 rows, others differ). */

  function previewRowsForLetter(letter, total, cols) {

    if (total <= cols) return 1;

    if (total <= cols * 2) return 2;

    var code = letter.charCodeAt(0) || 65;

    // A→2, B→3, C→2, D→3… so not every section looks identical

    return code % 2 === 0 ? 2 : 3;

  }



  /**

   * King & McGaw overview: multi-row 4-col grid, then blue "(N)…"

   * when there are more artists than the preview slots.

   * "(N)…" navigates to the letter page (?letter=X), not expand-in-place.

   */

  function renderPreviewGrid(grid, list, letter, cols) {

    if (!grid || !list.length) return;

    cols = cols || 4;

    var rows = previewRowsForLetter(letter, list.length, cols);

    var capacity = rows * cols;

    var needsMore = list.length > capacity;

    var showCount = needsMore ? capacity - 1 : list.length;



    grid.innerHTML = '';

    list.slice(0, showCount).forEach(function (a) {

      grid.insertAdjacentHTML('beforeend', chipHtml(a, 'first-last'));

    });

    if (needsMore) {

      var more = document.createElement('a');

      more.className = 'artists-az__chip artists-az__more ala-more-chip';

      more.setAttribute('data-letter', letter);

      more.setAttribute('href', letterHref(letter));

      more.setAttribute('aria-label', letter + ' harfi — tüm sanatçılar');

      more.setAttribute('data-ala-more-count', String(list.length - showCount));

      more.textContent = '(' + (list.length - showCount) + ')…';

      grid.appendChild(more);

    }

  }



  function letterHref(letter) {

    try {

      var url = new URL(window.location.href);

      url.searchParams.set('letter', letter);

      url.hash = '';

      return url.pathname + url.search;

    } catch (e) {

      return '?letter=' + encodeURIComponent(letter);

    }

  }



  function overviewHref() {

    try {

      var url = new URL(window.location.href);

      url.searchParams.delete('letter');

      url.hash = '';

      var q = url.searchParams.toString();

      return url.pathname + (q ? '?' + q : '');

    } catch (e) {

      return window.location.pathname || '';

    }

  }



  function init(root) {

    var jsonEl = root.querySelector('[data-artists-json]');

    var alphaEl = root.querySelector('[data-artists-alpha]');

    var bodyEl = root.querySelector('[data-artists-body]');

    if (!jsonEl || !alphaEl || !bodyEl) return;



    var artists = [];

    try {

      artists = JSON.parse(jsonEl.textContent || '[]');

    } catch (e) {

      bodyEl.innerHTML = '<p class="artists-az__msg">Sanatçı listesi okunamadı.</p>';

      return;

    }



    var allLabel = root.getAttribute('data-all-label') || 'Tümü';

    var emptyLabel = root.getAttribute('data-empty-label') || 'Bu harfte sanatçı yok.';

    var cols = parseInt(

      getComputedStyle(root).getPropertyValue('--artists-az-cols').trim() || '4',

      10

    );

    if (!cols || cols < 2) cols = 4;



    var grouped = groupByLetter(artists);

    var active = null;



    function availableLetters() {

      return LETTERS.filter(function (L) {

        return grouped[L] && grouped[L].length > 0;

      });

    }



    function renderAlpha() {

      var avail = availableLetters();

      var html = '';

      html +=

        '<a class="artists-az__all' +

        (active === null ? ' is-active' : '') +

        '" data-letter="" href="' +

        escapeHtml(overviewHref()) +

        '">' +

        escapeHtml(allLabel) +

        '</a>';

      LETTERS.forEach(function (L) {

        var has = avail.indexOf(L) !== -1;

        html +=

          '<a class="artists-az__letter' +

          (has ? ' is-available' : '') +

          (active === L ? ' is-active' : '') +

          '" data-letter="' +

          L +

          '"' +

          (has ? ' href="' + escapeHtml(letterHref(L)) + '"' : ' aria-disabled="true" tabindex="-1"') +

          '>' +

          L +

          '</a>';

      });

      alphaEl.innerHTML = html;

    }



    function renderOverview() {

      root.classList.remove('is-letter-mode');

      var avail = availableLetters();

      if (!avail.length) {

        bodyEl.innerHTML = '<p class="artists-az__msg">' + escapeHtml(emptyLabel) + '</p>';

        return;

      }

      var html = '';

      avail.forEach(function (L) {

        html +=

          '<section class="artists-az__section" id="artists-letter-' +

          L +

          '" data-letter="' +

          L +

          '">';

        html += '<div class="artists-az__section-head">';

        html += '<h2 class="artists-az__section-letter">' + L + '</h2>';

        html += '<hr class="artists-az__section-rule" />';

        html += '</div>';

        html += '<div class="artists-az__grid artists-az__grid--preview"></div>';

        html += '</section>';

      });

      bodyEl.innerHTML = html;



      bodyEl.querySelectorAll('.artists-az__section[data-letter]').forEach(function (section) {

        var L = section.getAttribute('data-letter');

        var grid = section.querySelector('.artists-az__grid--preview');

        renderPreviewGrid(grid, grouped[L] || [], L, cols);

      });

    }



    /** Letter page: dense multi-column list, SURNAME, FIRSTNAME. */

    function renderLetter(L) {

      root.classList.add('is-letter-mode');

      var list = grouped[L] || [];

      var html = '';

      html += '<section class="artists-az__section artists-az__section--filtered">';

      html += '<div class="artists-az__section-head">';

      html += '<h2 class="artists-az__section-letter">' + L + '</h2>';

      html += '<hr class="artists-az__section-rule" />';

      html += '</div>';

      if (!list.length) {

        html += '<p class="artists-az__msg">' + escapeHtml(emptyLabel) + '</p>';

      } else {

        html += '<div class="artists-az__grid artists-az__grid--letter">';

        list.forEach(function (a) {

          html += chipHtml(a, 'surname-first');

        });

        html += '</div>';

      }

      html += '</section>';

      bodyEl.innerHTML = html;

    }



    function scrollToIndex() {

      try {

        var top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);

        window.scrollTo({ top: Math.max(0, top - 24), behavior: 'smooth' });

      } catch (e) {

        /* ignore */

      }

    }



    function setActive(letter, opts) {

      opts = opts || {};

      active = letter || null;

      renderAlpha();

      if (active) renderLetter(active);

      else renderOverview();

      var url = new URL(window.location.href);

      if (active) url.searchParams.set('letter', active);

      else url.searchParams.delete('letter');

      if (opts.push) {

        window.history.pushState({ artistsAzLetter: active }, '', url);

      } else {

        window.history.replaceState({ artistsAzLetter: active }, '', url);

      }

      if (opts.scroll) scrollToIndex();

    }



    root.addEventListener('click', function (e) {

      var moreBtn = e.target.closest('.artists-az__more');

      if (moreBtn && root.contains(moreBtn)) {

        e.preventDefault();

        var moreL = (moreBtn.getAttribute('data-letter') || '').toUpperCase();

        if (moreL && LETTERS.indexOf(moreL) !== -1) {

          setActive(moreL, { push: true, scroll: true });

        }

        return;

      }



      var btn = e.target.closest('[data-letter]');

      if (!btn || !root.contains(btn)) return;

      // Only A–Z / Tümü nav (not artist chips)

      if (!btn.classList.contains('artists-az__letter') && !btn.classList.contains('artists-az__all')) {

        return;

      }

      if (btn.getAttribute('aria-disabled') === 'true') {

        e.preventDefault();

        return;

      }

      e.preventDefault();

      var L = (btn.getAttribute('data-letter') || '').toUpperCase();

      if (!L) setActive(null, { push: true, scroll: true });

      else setActive(L, { push: true, scroll: true });

    });



    window.addEventListener('popstate', function () {

      var params = new URLSearchParams(window.location.search);

      var L = (params.get('letter') || '').toUpperCase();

      if (L && LETTERS.indexOf(L) !== -1 && grouped[L] && grouped[L].length) {

        active = L;

        renderAlpha();

        renderLetter(L);

      } else {

        active = null;

        renderAlpha();

        renderOverview();

      }

    });



    var params = new URLSearchParams(window.location.search);

    var initial = (params.get('letter') || '').toUpperCase();

    if (initial && LETTERS.indexOf(initial) !== -1 && grouped[initial] && grouped[initial].length) {

      setActive(initial, { push: false, scroll: false });

    } else if (bodyEl.getAttribute('data-ssr') === '1' && alphaEl.getAttribute('data-ssr') === '1') {

      active = null;

    } else {

      setActive(null, { push: false, scroll: false });

    }

  }



  ready(function () {

    document.querySelectorAll('[data-artists-az]').forEach(init);

  });

})();


